import { render, staticRenderFns } from "./ChoiceEditor.vue?vue&type=template&id=2e6ba794"
import script from "./ChoiceEditor.vue?vue&type=script&lang=js"
export * from "./ChoiceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports